export class UpdateExpositionNette
{
    fournisseurAgreeId: number;
    expositionNette: number;
}